import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { Pagination } from "react-bootstrap";
import { ReactComponent as First } from "../../images/First.svg";
import { ReactComponent as DisabledFirst } from "../../images/disabled_first.svg";
import { ReactComponent as Last } from "../../images/Last.svg";
import { ReactComponent as DisabledLast } from "../../images/disabled_last.svg";
import { ReactComponent as Next } from "../../images/Next.svg";
import { ReactComponent as DisabledNext } from "../../images/disabled_next.svg";
import { ReactComponent as Prev } from "../../images/Prev.svg";
import { ReactComponent as DisabledPrev } from "../../images/disabled_prev.svg";
import {
    BUTTON,
    DEFAULT_PAGINATION_SIZE
} from "../../utils/constants";
import "./Pagination.module.css";
import styles from "./Pagination.module.css";
import {Button} from "@base-ui/react/button";

export default function NormalPagination({pageIndex, pageOptions, pageCount, canPreviousPage, canNextPage, previousPage, nextPage, gotoPage, paddingTop="10px"}) {
    const { t } = useTranslation();
    const paginationSize = DEFAULT_PAGINATION_SIZE;
    const getOpts = () => {
        // console.log(pageCount, paginationSize, pageIndex, pageOptions);

        //less than pagination size
        if (pageCount <= paginationSize) {
            return pageOptions;
        }

        //general
        if (pageIndex - paginationSize / 2 >= 0 && pageIndex + paginationSize / 2  <= pageCount) {
            return pageOptions.slice(pageIndex - paginationSize / 2, pageIndex + paginationSize / 2);
        }

        //the left side pages is not enough to display
        if (pageIndex - paginationSize / 2 < 0) {
            return pageOptions.slice(0, paginationSize);
        }

        //the right side pages is not enough to display
        if (pageIndex + paginationSize / 2  > pageCount) {
            return pageOptions.slice(pageCount - paginationSize, pageCount);
        }
        return [];
    }

    const [displayedOpts, setDisplayedOpts] = useState(() => {
        return getOpts();
    });




    useEffect(() => {
        setDisplayedOpts(getOpts());
    }, [pageIndex, pageCount]);

    return (
        <div className={styles.paginationContainer} style={{paddingTop: paddingTop}} role={"navigation"} aria-label={t("accessibility.paginationMenuText")}>
            <Button
                className={canPreviousPage ? styles.paginationItem : styles.paginationItemDisabled}
                onClick={() => {
                    if (canPreviousPage) gotoPage(0)
                }}
                tabIndex={canPreviousPage ? 0 : -1}
                aria-label={t("accessibility.firstPage")}
                disabled={!canPreviousPage}
            >
                {canPreviousPage ? <First style={{height: 12, width:12}} /> : <DisabledFirst style={{height: 12, width:12}}/>}
            </Button>
            <Button
                className={canPreviousPage ? styles.paginationItem : styles.paginationItemDisabled}
                onClick={() => {
                    if (canPreviousPage) previousPage()
                }}
                tabIndex={canPreviousPage ? 0 : -1}
                aria-label={t("accessibility.previousPage")}
                disabled={!canPreviousPage}
            >
               {canPreviousPage ?  <Prev style={{height: 20, width:20}}/> : <DisabledPrev style={{height: 20, width:20}}/>}
            </Button>
            {displayedOpts.map((idx, i) => {
                return (
                    <Button
                        key={i}
                        className={pageIndex === idx ? styles.paginationItemActive : styles.paginationItem}
                        onClick={() => gotoPage(idx)}
                        aria-label={t("accessibility.currentPage")+(idx+1)}
                    >
                        {idx + 1}
                    </Button>
                )
            })}
            <Button
                className={canNextPage ? styles.paginationItem : styles.paginationItemDisabled}
                onClick={() => {
                    if (canNextPage) nextPage()
                }}
                tabIndex={canNextPage ? 0 : -1}
                aria-label={t("accessibility.nextPage")}
                disabled={!canNextPage}
            >
                {canNextPage ? <Next style={{height: 20, width:20}}/> : <DisabledNext style={{height: 20, width:20}}/>}
            </Button>
            <Button
                className={canNextPage ? styles.paginationItem : styles.paginationItemDisabled}
                onClick={() => {
                    if (canNextPage) gotoPage(pageCount-1)
                }}
                tabIndex={canNextPage ? 0 : -1}
                aria-label={t("accessibility.lastPage")}
                disabled={!canNextPage}
            >
                {canNextPage ? <Last style={{height: 12, width:12}}/> : <DisabledLast style={{height: 12, width:12}}/>}
            </Button>
        </div>
        // Old :
        // <Pagination>
        //     <Pagination.First onClick={() => gotoPage(0)} disabled={!canPreviousPage} />
        //     <Pagination.Prev onClick={() => previousPage()} disabled={!canPreviousPage} />
        //     {displayedOpts.map((idx, i) => {
        //         return (
        //             <Pagination.Item
        //                 key={i}
        //                 active={pageIndex === idx}
        //                 onClick={() => gotoPage(idx)}>
        //                 {idx + 1}
        //             </Pagination.Item>
        //         );
        //     })}
        //     <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage} />
        //     <Pagination.Last onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} />
        // </Pagination>
    );
}